import { z } from "zod"

export const SafeSkyBeaconSchema = z.object({
    id: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    altitude: z.number().nullish(),
    course: z.number().nullish(),
    ground_speed: z.number().nullish(),
    vertical_rate: z.number().nullish(),
    call_sign: z.string().nullish(),
    beacon_type: z.string().nullish(),
    transponder_type: z.string().nullish(),
    status: z.string().nullish(),
    last_update: z.number().nullish(),
    accuracy: z.number().nullish(),
    altitude_accuracy: z.number().nullish(),
    turn_rate: z.number().nullish(),
    remarks: z.string().nullish(),
    operation_area: z.string().nullish(),
})

export type SafeSkyBeacon = z.infer<typeof SafeSkyBeaconSchema>

export const SafeSkyUavResponseSchema = z.array(SafeSkyBeaconSchema)

export type SafeSkyUavResponse = z.infer<typeof SafeSkyUavResponseSchema>
